
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/[id]",
      function () {
        return require("private-next-pages/ai/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/[id]"])
      });
    }
  